module.exports = __webpack_public_path__ + "static/media/DEVICE_COMPATIBILITY_CHECKER.test.js.9b2335d1.snap";